<template>
  <div>
    <section>
      <div class="left">
        <detail-entity-info
            :entity="entity"
            :omit-default="['id_remote']"
        >
          <p v-if="entity.origin_url">
            <translate class="translate">Zdroj</translate>
            :<br/><a @click="goToOrigin(entity.origin_url)" v-translate>Zdrojový záznam</a></p>
        </detail-entity-info>
      </div>
      <div class="right">
        <div class="field_left">
          <checkbox-input
              v-if="disabled"
              id="enabled"
              v-model="entity.enabled"
              :disabled="disabled"
          >
            <translate class="translate">Povoleno</translate>
          </checkbox-input>
          <text-input
              id="name"
              v-model="entity.name"
              :disabled="disabled"
          >
            <translate class="translate">Název</translate>
          </text-input>
          <select-box
              id="id_epg"
              :options="epgChannels"
              v-model="entity.id_epg"
              :disabled="disabled"
              :required="true"
              ref="idepgref"
          >
            <translate class="translate">Id EPG</translate>
          </select-box>
          <date-picker edit-time
                       id="from_timestamp"
                       date-format="d. m. yy"
                       attrKey="from_timestamp"
                       v-model="entity.from_timestamp"
                       @update-date="updateDate"
                       :disabled="disabled"
                       :per-minutes="true"
          >
            <translate class="translate">Zobrazit od *</translate>
          </date-picker>
          <date-picker edit-time
                       id="to_timestamp"
                       date-format="d. m. yy"
                       attrKey="to_timestamp"
                       v-model="entity.to_timestamp"
                       @update-date="updateDate"
                       :disabled="disabled"
                       :per-minutes="true"
          >
            <translate class="translate">Zobrazit do *</translate>
          </date-picker>
        </div>
        <div class="field_right">
          <text-input
              id="reason"
              v-model="entity.reason"
              :disabled="disabled"
          >
            <translate class="translate">Důvod blokace</translate>
          </text-input>
          <checkbox-input
              id="reflect_overlaps"
              v-model="entity.reflect_overlaps"
              :disabled="disabled"
          >
            <translate class="translate">Použít reálné overlapy</translate>
          </checkbox-input>
          <checkbox-input
              id="allow_catchup"
              v-model="entity.allow_catchup"
              :disabled="disabled"
          >
            <translate class="translate">Povolit catch-up</translate>
          </checkbox-input>
          <checkbox-input
              id="allow_timeshift"
              v-model="entity.allow_ts"
              :disabled="disabled"
          >
            <translate class="translate">Povolit timeshift</translate>
          </checkbox-input>
          <checkbox-input
              id="allow_pvr"
              v-model="entity.allow_pvr"
              :disabled="disabled"
          >
            <translate class="translate">Povolit PVR</translate>
          </checkbox-input>
        </div>
      </div>
    </section>
    <section>
      <div class="left">
        <h2 v-translate>Nastavení regionů</h2>
        <p v-translate>Pokud nejsou vyplněny ani povolené ani zakázané regiony, je obsah zakázán globálně ve všech regionech.</p>
      </div>
      <div class="right">
        <multiselect-searchbox
            :searchFunction="searchRegions"
            v-model="entity.allowed_regions"
            :show-id="true"
            :disabled="disabled"
            :string-ids="true"
        >{{$gettext('Obsah povolen v regionech')}}</multiselect-searchbox>
        <multiselect-searchbox
            :searchFunction="searchRegions"
            v-model="entity.restricted_regions"
            :show-id="true"
            :disabled="disabled"
            :string-ids="true"
        >{{$gettext('Obsah zakázán v regionech')}}</multiselect-searchbox>
      </div>
    </section>
    <section v-if="entity.id_remote && !$_loggedUser_selectedOperatorId && $_loggedUser_canChangeOperator">
      <div class="left">
        <h2 v-translate>Povolit pro Business modely</h2>
      </div>
      <div class="right">
        <div v-for="(value, key) in entity.enabled_override" class="field_left">
          <select-box
              :id="'bussinessmodelenabled_'+key"
              :options="businessModelOptions"
              v-model="entity.enabled_override[key]['value']"
              :disabled="!$_updateActionAllowed"
              :ref="'bussinessmodelenabled_'+key+'_ref'"
          >
            {{value['name']}}
          </select-box>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Message from "../../../mixins/message";
import DetailEntityInfo from "../../../common/DetailEntityInfo.vue";
import {stateIsoCodeToNameMap, normalizeStringLowercase, getBooleanOrNullListOptions} from "../../../../utils/helpers";

export default {
  name: "ThematicGroupBasicForm",
  components: {DetailEntityInfo},
  mixins: [Message],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data() {
    return {
      epgChannels: [],
    }
  },
  created(BlackoutContentService, ChannelService) {
    this.entityService = BlackoutContentService;
    this.channelService = ChannelService;
    this.channelService.epgChannelList()
        .then((data) => {
          this.epgChannels = Object.values(data['channels']);
        });
  },
  computed: {
    businessModelOptions(){
      return getBooleanOrNullListOptions(this);
    },
    disabled() {
      return !this.isEditable || !this.$_updateActionAllowed;
    },
  },
  methods: {
    goToOrigin(url) {
      window.open(url, '_blank');
    },
    updateDate(dateInfo) {
      this.entity[dateInfo.attrKey] = dateInfo.date
    },
    searchRegions(search, selectAll = false) {
      return new Promise((resolve) =>
      {
        const regions = stateIsoCodeToNameMap(this);
        const remapedRegions = Object.entries(regions).map(([id, text]) => {
          return {
            id: id,
            text: text
          }
        });
        if(selectAll) {
          resolve({data: remapedRegions});
        }else{
          let filteredRegions = null;
          if(search.length > 0){
            const normalizedQuery = normalizeStringLowercase(search);
            filteredRegions = remapedRegions.filter(({id, text}) => {
              const normalizedText = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
              return id.toLowerCase().includes(normalizedQuery) || normalizedText.includes(normalizedQuery);
            });
          }else{
            filteredRegions = remapedRegions;
          }
          resolve({data: filteredRegions.slice(0,20)});
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/blackoutContents/forms/BlackoutContentBasicForm.vue